import createVueComponent from '../createVueComponent';

const RadioReceiver = createVueComponent('RadioReceiverIcon', [
  ['path', { d: 'M5 16v2' }],
  ['path', { d: 'M19 16v2' }],
  ['rect', { x: '2', y: '8', width: '20', height: '8', rx: '2' }],
  ['path', { d: 'M18 12h0' }],
]);

export default RadioReceiver;
